import { getClient } from '@zg-rentals/ts-client-http-client';

/**
 * Shared HTTP client for calls to backends fronted at the `/rental` path
 * (capps, maintenance-tracker, rent-payment, z-calendar, satellite).
 */
export const client = getClient().extend({ prefixUrl: process.env.NEXT_PUBLIC_RENTAL_PREFIX });

/**
 * z-calendar alone can be pointed at a local Tomcat (`NEXT_PUBLIC_ZCALENDAR_PREFIX_URL`, e.g.
 * `https://localhost:8443/`) while every other backend keeps using the shared prefix.
 */
export const zCalendarClient = process.env.NEXT_PUBLIC_ZCALENDAR_PREFIX_URL
  ? client.extend({ prefixUrl: process.env.NEXT_PUBLIC_ZCALENDAR_PREFIX_URL })
  : client;
